import React from 'react';
import TeamsManagement from '../components/settings/TeamsManagement';

const TeamsPage = () => {
  return <TeamsManagement />;
};

export default TeamsPage;